import React from 'react'

const Filler = (props) => {
  return <div className={props.fillerClass} style={{ width: `${props.percentage}%` }} />
}

export default Filler
